import {AfterContentChecked, ChangeDetectorRef, Component, forwardRef, OnInit} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, NG_VALUE_ACCESSOR, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UntilDestroy } from '@ngneat/until-destroy';
import { formControlErrorKeys, formControlErrorMessage, setupUntilDestroy } from '@portal-workspace/grow-ui-library';
import { MARK, Mark } from '@portal-workspace/grow-ui-library/mark';
import { createBsbInputMask } from '@portal-workspace/grow-ui-library';
import { Subscription } from 'rxjs';
import { AbstractControlValueAccessor } from '../abstract-control-value-accessor';
import { delay, distinctUntilChanged, tap } from 'rxjs/operators';
import {BsbComponentValue, compareMatch} from '@portal-workspace/grow-shared-library';

import { InputMaskModule } from '@ngneat/input-mask';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import {DisableControlDirective} from '../../directives/disable-control.directive';

@UntilDestroy()
@Component({
    selector: 'bsb',
    templateUrl: './bsb.component.html',
    styleUrls: ['./bsb.component.scss'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => BsbComponent), multi: true },
        { provide: MARK, useExisting: forwardRef(() => BsbComponent) },
    ],
    standalone: true,
    imports: [MatFormFieldModule, MatInputModule, FormsModule, InputMaskModule, ReactiveFormsModule, DisableControlDirective]

})

export class BsbComponent extends AbstractControlValueAccessor<BsbComponentValue> implements OnInit, AfterContentChecked, Mark {
  errorKeys = formControlErrorKeys;
  errorMessage = formControlErrorMessage;
  formControl!: FormControl;
  formGroup!: FormGroup;
  subscription?: Subscription;
  createBsbInputMask = createBsbInputMask();


  constructor(private formBuilder: FormBuilder,
              private cdr: ChangeDetectorRef) {
    super();
  }

  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }


  ngOnInit(): void {
    setupUntilDestroy(this);
    this.formControl = new FormControl(null, [Validators.required]);
    this.formGroup = this.formBuilder.group({
      bsb: this.formControl,
    });
    this.subscription = this.formControl.valueChanges.pipe(
      delay(0),
      distinctUntilChanged(compareMatch),
      tap((v: any) => {
        if (this.formGroup.valid) {
          this.propagateChange(v);
        } else {
          this.propagateChange(null)
        }
      })
    ).subscribe();
  }


  doWriteValue(v: BsbComponentValue) {
    this.formControl.setValue(v);
  }


  mark(): void {
    this.formControl.markAllAsTouched();
  }
}
